/**
 * @generated SignedSource<<671909c9dc35d48e3af6436180dd2698>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightPriceHistoryRow_entry$data = {
  readonly actualPrice: number;
  readonly createdAt: string;
  readonly newPrice: number;
  readonly priceChange: number;
  readonly serviceMessage: string | null;
  readonly status: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"FlightPriceChangeIcon_entry">;
  readonly " $fragmentType": "FlightPriceHistoryRow_entry";
};
export type FlightPriceHistoryRow_entry$key = {
  readonly " $data"?: FlightPriceHistoryRow_entry$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightPriceHistoryRow_entry">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlightPriceHistoryRow_entry",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceChange",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "newPrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceMessage",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FlightPriceChangeIcon_entry"
    }
  ],
  "type": "FlightPrice",
  "abstractKey": null
};

(node as any).hash = "77276f6aa7b426be90300c9fc73dc12f";

export default node;
